import Vue from 'vue'
import { MediaQueries } from 'vue-media-queries'
import App from './App.vue'
import * as utils from '@/libs/utils'
import store from '@/store'
import Vue2TouchEvents from 'vue2-touch-events'
import pj from '../package.json'

console.log('App ver: ', pj.version) //eslint-disable-line

const mediaQueries = new MediaQueries()

Vue.use(mediaQueries)
Vue.use(Vue2TouchEvents)

const filterNames = Object.keys(utils)

for (const filter of filterNames) {
  Vue.filter(filter, utils[filter])
}

Vue.config.productionTip = false

new Vue({
  mediaQueries,
  store,
  render: (h) => h(App),
}).$mount('#app')
